module.exports = __webpack_public_path__ + "assets/img/perle_double_back.18f0efaa.svg";